(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalOrderContactSearch', AppraisalOrderContactSearch);

    AppraisalOrderContactSearch.$inject = ['$resource'];

    function AppraisalOrderContactSearch($resource) {
        var resourceUrl =  'api/_search/appraisal-order-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
